import React, { useEffect } from "react";
import "../product/Drop.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay } from 'swiper/modules';
import BottomContact from "../../components/BottomContact/BottomContact";
function Drop() {
  useEffect(() => {
    const ele = document.getElementById("home-drop");
    if (ele.scrollTop < ele.clientHeight) {
      document.getElementById("navbar").style.color = "black";
      document.getElementById("logoImg").src = "/images/logo.png";
      document.querySelector(".mobile-nav-toggle").classList.remove("whiteToggle");
      document.getElementById("menu-toggle-container").style.display = "none";
      document.querySelector(".mobile-nav-toggle").classList.add("active");
      document.querySelector(".item-list").classList.add("active");
      document.getElementById("container-list1").style.color = "black";
      document.getElementById("container-list2").style.color = "black";
      document.getElementById("container-list3").style.color = "black";

    }
  }, [])
  const handleScroll = () => {
    const ele = document.getElementById("home-drop");
    if (ele.scrollTop < ele.clientHeight) {
      document.getElementById("navbar").style.color = "black";
      document.getElementById("logoImg").src = "/images/logo.png";
      document.querySelector(".mobile-nav-toggle").classList.remove("whiteToggle");
      document.getElementById("menu-toggle-container").style.display = "none";
      document.querySelector(".mobile-nav-toggle").classList.add("active");
      document.querySelector(".item-list").classList.add("active");
      document.getElementById("container-list1").style.color = "black";
      document.getElementById("container-list2").style.color = "black";
      document.getElementById("container-list3").style.color = "black";

    } else if (ele.scrollTop < (ele.clientHeight * 3) - 2) {
      document.getElementById("navbar").style.color = "white";
      document.getElementById("logoImg").src = "/images/logoWhite.png";
      document.querySelector(".mobile-nav-toggle").classList.add("whiteToggle");
      document.getElementById("menu-toggle-container").style.display = "flex";
      document.querySelector(".mobile-nav-toggle").classList.remove("active");
      document.querySelector(".item-list").classList.remove("active");
      document.getElementById("container-list1").style.color = "white";
      document.getElementById("container-list2").style.color = "white";
      document.getElementById("container-list3").style.color = "white";

    }
    else if (ele.scrollTop > ele.clientHeight * 4.56) {
      document.getElementById("navbar").style.color = "white";
      document.getElementById("logoImg").src = "/images/logoWhite.png";
      document.querySelector(".mobile-nav-toggle").classList.add("whiteToggle");
      document.getElementById("menu-toggle-container").style.display = "flex";
      document.querySelector(".mobile-nav-toggle").classList.remove("active");
      document.querySelector(".item-list").classList.remove("active");
      document.getElementById("container-list1").style.color = "white";
      document.getElementById("container-list2").style.color = "white";
      document.getElementById("container-list3").style.color = "white";

    } else {
      document.getElementById("navbar").style.color = "black";
      document.getElementById("logoImg").src = "/images/logo.png";
      document.querySelector(".mobile-nav-toggle").classList.remove("whiteToggle");
      document.getElementById("container-list1").style.color = "black";
      document.getElementById("container-list2").style.color = "black";
      document.getElementById("container-list3").style.color = "black";
      document.querySelector(".item-list").classList.remove("active");
      document.querySelector(".mobile-nav-toggle").classList.remove("active");
    }
  }

  const routeToContactUs = () => {
    document.getElementById('blur-div').style.visibility = 'visible'
  }
  return (
    <div className="drop-main-container" style={{ height: "100vh", width: "100%", overflow: "auto" }} id="home-drop" onScroll={handleScroll}>
      {/* First page */}
      <div className="Drop-first-page Bustracaking-first-page">
        <div className="Drop-first-page-sub-div">
          <svg width="25" height="35" viewBox="0 0 25 35" fill="none" xmlns="http://www.w3.org/2000/svg" id="drop-vector-1">
            <path d="M20.3246 32.0608L2.06956 20.5244L13.7065 2.11013C23.0983 8.92931 25.9511 21.7806 20.3246 32.0608Z" stroke="#FF8402" strokeWidth="3" />
          </svg>
          <svg width="41" height="48" viewBox="0 0 41 48" fill="none" xmlns="http://www.w3.org/2000/svg" id="drop-vector-2">
            <path d="M31.5156 47.5254L40.2967 8.71345L1.78099 -0.000564967C-3.06902 21.4364 10.2423 42.7124 31.5156 47.5254Z" fill="#E9E5D9" />
          </svg>

          <svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg" id="drop-vector-3">
            <path d="M1.83624 26.6688L8.22156 1.82641L33.2767 8.26642C29.1029 21.4613 15.533 29.4193 1.83624 26.6688Z" stroke="#FF8402" strokeWidth="3" />
          </svg>

          <svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg" id="drop-vector-4">
            <path d="M1.83624 26.6688L8.22156 1.82641L33.2767 8.26642C29.1029 21.4613 15.533 29.4193 1.83624 26.6688Z" stroke="#272D2F" strokeWidth="3" />
          </svg>

          <svg width="40" height="34" viewBox="0 0 40 34" fill="none" xmlns="http://www.w3.org/2000/svg" id="drop-vector-5">
            <path d="M0 26.5L32.7491 33.3813L39.5779 0.882174C21.4896 -2.91856 3.77172 8.54981 0 26.5Z" fill="#FF8402" />
          </svg>

          <svg width="41" height="48" viewBox="0 0 41 48" fill="none" xmlns="http://www.w3.org/2000/svg" id="drop-vector-6">
            <path d="M31.5156 47.5234L40.2967 8.71149L1.78099 -0.00251809C-3.06902 21.4344 10.2423 42.7104 31.5156 47.5234Z" fill="#E9E5D9" />
          </svg>

          <div className="Drop-first-page-sub-container">
            <div className="Drop-first-page-text-content">
              <div className="Drop-heading">
                <h1 id="Drop">Drop</h1>
              </div>
              <div className="Drop-paragraph">
                <p>
                  Monitoring Water storage irrespective of their storage capacities was the main objective behind this product. It contains a pack of water level monitoring loT device along with a dedicated android application for controls & to show data analytics. For the sake of water conservation, the app gives alerts of excessive water usage, overflow alerts, water pump operation buttons.
                </p>
              </div>
              <div className="Drop-enquire-now">
                <div className='drop-enquire-now-btn connect' id='connectBtn' onClick={() => routeToContactUs()}><p>Enquire Now</p></div>
              </div>
            </div>
            <div className="Drop-first-image-content">
              <img src="/images/Drop.png" alt="/" id="Drop-image" />
            </div>
          </div>
        </div>
      </div>
      {/* First page end */}

      {/* Second page Start */}
      <div className="Drop-Second-page">
        <svg width="25" height="35" viewBox="0 0 25 35" fill="none" xmlns="http://www.w3.org/2000/svg" id="Dropsecondpage-vector-1">
          <path d="M20.3246 32.0608L2.06956 20.5244L13.7065 2.11013C23.0983 8.92931 25.9511 21.7806 20.3246 32.0608Z" stroke="#FF8402" strokeWidth="3" />
        </svg>

        <svg width="41" height="57" viewBox="0 0 41 57" fill="none" xmlns="http://www.w3.org/2000/svg" id="Dropsecondpage-vector-2">
          <path d="M28.5977 0L0.000218118 28.3257L28.1097 56.7048C43.9048 41.0597 44.1233 15.6746 28.5977 0Z" fill="#FF8402" />
        </svg>

        <svg width="41" height="48" viewBox="0 0 41 48" fill="none" xmlns="http://www.w3.org/2000/svg" id="Dropsecondpage-vector-3">
          <path d="M31.5156 47.5234L40.2967 8.71149L1.78099 -0.00251809C-3.06902 21.4344 10.2423 42.7104 31.5156 47.5234Z" fill="#E9E5D9" />
        </svg>

        <svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg" id="Dropsecondpage-vector-4">
          <path d="M1.83624 26.6688L8.22156 1.82641L33.2767 8.26642C29.1029 21.4613 15.533 29.4193 1.83624 26.6688Z" stroke="#CBA021" strokeWidth="3" />
        </svg>

        <svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg" id="Dropsecondpage-vector-5">
          <path d="M1.83624 26.6688L8.22156 1.82641L33.2767 8.26642C29.1029 21.4613 15.533 29.4193 1.83624 26.6688Z" stroke="#E9E5D9" strokeWidth="3" />
        </svg>

        <div className="Drop-second-page-logo">
          <svg width="394" height="84" viewBox="0 0 394 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.32 39V11H9.8V39H3.32ZM29.085 17.16C34.165 17.16 38.005 20.12 38.005 26.68V39H31.765V27.64C31.765 24.16 30.165 22.56 27.405 22.56C24.405 22.56 22.245 24.4 22.245 28.36V39H16.005V17.48H21.965V20C23.645 18.16 26.165 17.16 29.085 17.16ZM55.8613 33.56L57.5413 37.96C56.2613 38.88 54.3813 39.32 52.4613 39.32C47.3813 39.32 44.4213 36.72 44.4213 31.6V22.76H41.1013V17.96H44.4213V12.72H50.6613V17.96H56.0213V22.76H50.6613V31.52C50.6613 33.36 51.6613 34.36 53.3413 34.36C54.2613 34.36 55.1813 34.08 55.8613 33.56ZM67.0041 20.32C68.5241 18.24 71.0841 17.16 74.4041 17.16V22.92C73.8841 22.88 73.4841 22.84 73.0041 22.84C69.5641 22.84 67.2841 24.72 67.2841 28.84V39H61.0441V17.48H67.0041V20.32ZM88.1591 39.32C81.3191 39.32 76.3191 34.72 76.3191 28.24C76.3191 21.76 81.3191 17.16 88.1591 17.16C94.9991 17.16 99.9591 21.76 99.9591 28.24C99.9591 34.72 94.9991 39.32 88.1591 39.32ZM88.1591 34.2C91.2791 34.2 93.6391 31.96 93.6391 28.24C93.6391 24.52 91.2791 22.28 88.1591 22.28C85.0391 22.28 82.6391 24.52 82.6391 28.24C82.6391 31.96 85.0391 34.2 88.1591 34.2ZM136.378 11H142.818L130.698 39H124.298L112.218 11H119.218L127.738 31L136.378 11ZM148.227 14.48C145.907 14.48 144.347 12.96 144.347 11C144.347 9.04 145.907 7.52 148.227 7.52C150.547 7.52 152.107 8.96 152.107 10.88C152.107 12.96 150.547 14.48 148.227 14.48ZM145.107 39V17.48H151.347V39H145.107ZM172.818 9.32H179.058V39H173.098V36.52C171.538 38.4 169.258 39.32 166.378 39.32C160.298 39.32 155.618 35 155.618 28.24C155.618 21.48 160.298 17.16 166.378 17.16C169.018 17.16 171.258 18 172.818 19.76V9.32ZM167.458 34.2C170.538 34.2 172.938 31.96 172.938 28.24C172.938 24.52 170.538 22.28 167.458 22.28C164.338 22.28 161.938 24.52 161.938 28.24C161.938 31.96 164.338 34.2 167.458 34.2ZM205.913 28.32C205.913 28.8 205.833 29.48 205.793 30H189.513C190.113 32.68 192.393 34.32 195.673 34.32C197.953 34.32 199.593 33.64 201.073 32.24L204.393 35.84C202.393 38.12 199.393 39.32 195.513 39.32C188.073 39.32 183.233 34.64 183.233 28.24C183.233 21.8 188.153 17.16 194.713 17.16C201.033 17.16 205.913 21.4 205.913 28.32ZM194.753 21.88C191.913 21.88 189.873 23.6 189.433 26.36H200.033C199.593 23.64 197.553 21.88 194.753 21.88ZM220.308 39.32C213.468 39.32 208.468 34.72 208.468 28.24C208.468 21.76 213.468 17.16 220.308 17.16C227.148 17.16 232.108 21.76 232.108 28.24C232.108 34.72 227.148 39.32 220.308 39.32ZM220.308 34.2C223.428 34.2 225.788 31.96 225.788 28.24C225.788 24.52 223.428 22.28 220.308 22.28C217.188 22.28 214.788 24.52 214.788 28.24C214.788 31.96 217.188 34.2 220.308 34.2Z" fill="white" />
            <path d="M19.98 61H21.88L17.2 75H15.1L11.28 63.82L7.46 75H5.32L0.64 61H2.7L6.48 72.38L10.42 61H12.26L16.12 72.44L19.98 61ZM27.1058 64.3C30.0058 64.3 31.6458 65.7 31.6458 68.6V75H29.8258V73.6C29.1858 74.56 28.0058 75.12 26.3458 75.12C23.9458 75.12 22.4258 73.84 22.4258 72C22.4258 70.3 23.5258 68.9 26.6858 68.9H29.7258V68.52C29.7258 66.9 28.7858 65.96 26.8858 65.96C25.6258 65.96 24.3458 66.4 23.5258 67.1L22.7258 65.66C23.8258 64.78 25.4058 64.3 27.1058 64.3ZM26.6658 73.64C28.1058 73.64 29.2458 72.98 29.7258 71.76V70.28H26.7658C24.8658 70.28 24.3258 71.02 24.3258 71.92C24.3258 72.98 25.2058 73.64 26.6658 73.64ZM40.5589 73L41.1589 74.38C40.5789 74.88 39.6989 75.12 38.8389 75.12C36.6989 75.12 35.4789 73.94 35.4789 71.8V65.98H33.6789V64.4H35.4789V62.08H37.3989V64.4H40.4389V65.98H37.3989V71.72C37.3989 72.86 37.9989 73.5 39.0589 73.5C39.6189 73.5 40.1589 73.32 40.5589 73ZM47.7486 75.12C44.4886 75.12 42.1486 72.86 42.1486 69.7C42.1486 66.54 44.4886 64.3 47.7486 64.3C49.6486 64.3 51.2286 65.08 52.0686 66.56L50.6086 67.5C49.9286 66.46 48.8886 65.98 47.7286 65.98C45.6486 65.98 44.0886 67.44 44.0886 69.7C44.0886 72 45.6486 73.44 47.7286 73.44C48.8886 73.44 49.9286 72.96 50.6086 71.92L52.0686 72.84C51.2286 74.32 49.6486 75.12 47.7486 75.12ZM60.0777 64.3C62.6577 64.3 64.4777 65.78 64.4777 68.9V75H62.5577V69.12C62.5577 67.04 61.5177 66.02 59.6977 66.02C57.6577 66.02 56.3377 67.24 56.3377 69.54V75H54.4177V60.16H56.3377V65.9C57.1377 64.88 58.4577 64.3 60.0777 64.3ZM77.942 75.12C74.762 75.12 72.422 72.86 72.422 69.7C72.422 66.54 74.762 64.3 77.942 64.3C81.122 64.3 83.442 66.54 83.442 69.7C83.442 72.86 81.122 75.12 77.942 75.12ZM77.942 73.44C79.982 73.44 81.502 71.96 81.502 69.7C81.502 67.44 79.982 65.98 77.942 65.98C75.902 65.98 74.362 67.44 74.362 69.7C74.362 71.96 75.902 73.44 77.942 73.44ZM94.0573 64.4H95.9773V75H94.1573V73.4C93.3773 74.5 92.0573 75.12 90.5573 75.12C87.8173 75.12 85.9973 73.62 85.9973 70.5V64.4H87.9173V70.28C87.9173 72.36 88.9573 73.4 90.7773 73.4C92.7773 73.4 94.0573 72.16 94.0573 69.88V64.4ZM101.473 66.18C102.153 64.94 103.473 64.3 105.333 64.3V66.16C105.173 66.14 105.033 66.14 104.893 66.14C102.833 66.14 101.553 67.4 101.553 69.72V75H99.6325V64.4H101.473V66.18ZM118.827 64.3C121.927 64.3 124.187 66.46 124.187 69.7C124.187 72.96 121.927 75.12 118.827 75.12C117.327 75.12 116.007 74.54 115.127 73.4V78.88H113.207V64.4H115.047V66.08C115.907 64.9 117.267 64.3 118.827 64.3ZM118.667 73.44C120.707 73.44 122.247 71.96 122.247 69.7C122.247 67.46 120.707 65.98 118.667 65.98C116.647 65.98 115.107 67.46 115.107 69.7C115.107 71.96 116.647 73.44 118.667 73.44ZM126.84 75V60.16H128.76V75H126.84ZM136.285 64.3C139.185 64.3 140.825 65.7 140.825 68.6V75H139.005V73.6C138.365 74.56 137.185 75.12 135.525 75.12C133.125 75.12 131.605 73.84 131.605 72C131.605 70.3 132.705 68.9 135.865 68.9H138.905V68.52C138.905 66.9 137.965 65.96 136.065 65.96C134.805 65.96 133.525 66.4 132.705 67.1L131.905 65.66C133.005 64.78 134.585 64.3 136.285 64.3ZM135.845 73.64C137.285 73.64 138.425 72.98 138.905 71.76V70.28H135.945C134.045 70.28 133.505 71.02 133.505 71.92C133.505 72.98 134.385 73.64 135.845 73.64ZM149.739 73L150.339 74.38C149.759 74.88 148.879 75.12 148.019 75.12C145.879 75.12 144.659 73.94 144.659 71.8V65.98H142.859V64.4H144.659V62.08H146.579V64.4H149.619V65.98H146.579V71.72C146.579 72.86 147.179 73.5 148.239 73.5C148.799 73.5 149.339 73.32 149.739 73ZM156.54 61.62C155.4 61.62 154.82 62.26 154.82 63.48V64.4H157.9V65.98H154.86V75H152.94V65.98H151.14V64.4H152.94V63.46C152.94 61.4 154.18 60.04 156.44 60.04C157.26 60.04 158.06 60.24 158.6 60.66L158.02 62.12C157.62 61.82 157.1 61.62 156.54 61.62ZM164.094 75.12C160.914 75.12 158.574 72.86 158.574 69.7C158.574 66.54 160.914 64.3 164.094 64.3C167.274 64.3 169.594 66.54 169.594 69.7C169.594 72.86 167.274 75.12 164.094 75.12ZM164.094 73.44C166.134 73.44 167.654 71.96 167.654 69.7C167.654 67.44 166.134 65.98 164.094 65.98C162.054 65.98 160.514 67.44 160.514 69.7C160.514 71.96 162.054 73.44 164.094 73.44ZM174.09 66.18C174.77 64.94 176.09 64.3 177.95 64.3V66.16C177.79 66.14 177.65 66.14 177.51 66.14C175.45 66.14 174.17 67.4 174.17 69.72V75H172.25V64.4H174.09V66.18ZM193.576 64.3C196.156 64.3 197.916 65.78 197.916 68.9V75H195.996V69.12C195.996 67.04 194.996 66.02 193.256 66.02C191.336 66.02 190.076 67.24 190.076 69.54V75H188.156V69.12C188.156 67.04 187.156 66.02 185.416 66.02C183.496 66.02 182.236 67.24 182.236 69.54V75H180.316V64.4H182.156V65.98C182.916 64.9 184.216 64.3 185.816 64.3C187.436 64.3 188.796 64.94 189.496 66.26C190.296 65.06 191.776 64.3 193.576 64.3Z" fill="#FF8402" />
          </svg>

          <svg width="101" height="101" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg" id="Drop-secondpage-heading-circle">
            <circle cx="50.5" cy="50.5" r="50.5" fill="#E9E5D9" fill-opacity="0.34" />
          </svg>
        </div>
        <div className="DropSecondpage-video-image">
          <div className="drop-ytContainer">
            <img className="ytMobile" src="/images/ytmobile.png" alt="" />
            <iframe className="ytVideoDrop" width="560" height="315" src="https://www.youtube.com/embed/THr6Vveihx8?si=KhuYRyjzIq-O3-OU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            <img className="dropMobile" src="/images/dropMobile.png" alt="" />
          </div>
        </div>

        <div className="product-in-glanace">
          <div className="">
            <h1>Product in a glance</h1>
          </div>
          <div>
            <svg width="146" height="21" viewBox="0 0 146 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10.5" cy="10.5" r="10.5" fill="#FF8402" />
              <circle cx="52.5" cy="11.5" r="7.5" fill="white" fill-opacity="0.37" />
              <circle cx="95.5" cy="11.5" r="7.5" fill="white" fill-opacity="0.37" />
              <circle cx="138.5" cy="11.5" r="7.5" fill="white" fill-opacity="0.37" />
            </svg>
          </div>
        </div>

        <div className="Drop-secondpage-cards">
          <div className="Drop-secondpage-cards-scroller drop-product">
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              centeredSlides={true}
              pagination={{
                clickable: true,
              }}
              mousewheel={true}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 50,
                },
                1530: {
                  slidesPerView: 5,
                  spaceBetween: 50,
                },
                1700:{
                  slidesPerView: 5,
                  spaceBetween: 50,
                }

              }}
              navigation={false}
              modules={[Autoplay]}
              className="mySwiper"
            ><SwiperSlide>
                <div className="Drop-second-page-card-1 ">
                  <img src="/images/DropSecond-page-card-1-img.png" alt="/" />
                  <h1>RT-DAS</h1>
                  <p>The system offers real-time monitoring, providing users with current water level information for effective management.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="Drop-second-page-card-1 " id="Bustracking-second-page-card-2">
                  <img src="/images/BustrackingSecond-page-2-image.png" alt="/" />
                  <h1>Accuracy</h1>
                  <p>High accuracy is crucial in water level monitoring for reliable data and effective water management.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="Drop-second-page-card-1 " id="Bustracking-second-page-card-3">
                  <img src="/images/DropSecond-page-card-3-img.png" alt="/" />
                  <h1>Alerts</h1>
                  <p>Alerts for water overuse, overflow, and pump control promote conservation by detecting anomalies and preventing water wastage.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="Drop-second-page-card-1 " id="Bustracking-second-page-card-4">
                  <img src="/images/DropSecond-page-card-4-img.png" alt="/" />
                  <h1>Cost Efficiency</h1>
                  <p>Cost efficiency is vital for widespread adoption, requiring a balance between features and affordability for broader accessibility.</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
      {/* Second page End */}

      {/* Third page start */}
      {/* For Normal web */}

      <div className="Drop-third-page">
        
        {/* Drop-third-page-sub-div for laptop*/}
        <div className="Drop-third-page-sub-div">
          <div className="Drop-third-page-left-content">
            <div className="Drop-how-it-work">
              <svg width="101" height="101" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg" id="how-it-work-circle">
                <circle cx="50.5" cy="50.5" r="50.5" fill="#E9E5D9" />
              </svg>
              <h1>How it work</h1>
              <svg width="25" height="35" viewBox="0 0 25 35" fill="none" xmlns="http://www.w3.org/2000/svg" id="how-it-work-vector">
                <path d="M20.3246 32.0608L2.06956 20.5244L13.7065 2.11013C23.0983 8.92931 25.9511 21.7806 20.3246 32.0608Z" stroke="#FF8402" strokeWidth="3" />
              </svg>
            </div>

            <div className="drop-third-page-left-content">
              <div className="step-div">
                <div className="step01 step02">
                  <h1>Step 02</h1>
                </div>
                <img src="/images/Step-left-image.png" alt="/" id="Step-left-image" />
              </div>
              <div className="third-page-left-paragaph">

                <h1>Mobile App Set-Up</h1>

                <p>Download the Drop mobile application from play-store, enter the unique customer identification key to communicate with the installed device. Once the setup is complete, Drop starts gathering & logging data over the cloud.</p>
              </div>
            </div>
          </div>
          <div className="Drop-third-page-middle-content">
            <svg width="62" height="850" viewBox="0 0 62 850" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="32.5" y1="70.5" x2="32.5" y2="388.5" stroke="black" stroke-opacity="0.5" strokeWidth="5" stroke-linecap="round" stroke-dasharray="20 20" />
              <line x1="32.5" y1="472.5" x2="32.5" y2="775.5" stroke="black" stroke-opacity="0.5" strokeWidth="5" stroke-linecap="round" stroke-dasharray="20 20" />
              <circle cx="31" cy="31" r="29.5" stroke="#0065B8" strokeWidth="3" />
              <circle cx="31" cy="31" r="15" fill="#0065B8" />
              <circle cx="31" cy="819" r="29.5" stroke="#FF8402" strokeWidth="3" />
              <circle cx="31" cy="819" r="15" fill="#FF8402" />
              <circle cx="31" cy="430" r="29.5" stroke="#008F88" strokeWidth="3" />
              <circle cx="31" cy="430" r="15" fill="#008F88" />
            </svg>

          </div>
          <div className="Drop-third-page-right-content">
            <div className="Third-right-div-1">
              <img src="/images/step01-image.png" alt="/" id="step01-image" />
              <div className="step01">
                <h1>Step 01</h1>
              </div>
              <div className="step-1-paragraph">

                <h1>Device Installation</h1>
                <p>Install the device on the water tank for monitoring water level and connectivity with the water pump. This device comes with a unique customer identification key that helps access it through the mobile application.</p>
              </div>
            </div>

            <div className="Third-right-div-1 Third-right-div-2">

              <img src="/images/step03-image.png" alt="/" id="step03-image" />
              <div className="step-1-paragraph step-3-paragraph ">
                <div className="step01 step03">
                  <h1>Step 03</h1>
                </div>
                <h1>Device Installation</h1>
                <p>Install the device on the water tank for monitoring water level and connectivity with the water pump. This device comes with a unique customer identification key that helps access it through the mobile application.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Drop-third-page-sub-div for mobile*/}
        <div className="Drop-third-page-sub-div-mobile">
          <img src="/images/step-line.png" alt="/" id="step-line" />
          <div className="Drop-third-page-sub-div-mobile-content">
            <div className="mobile-step01-div">
              <div className="step01-mobile"><p className="step01-mobile-head">Step 01</p></div>
              <h3 id="step01-h3">device installation</h3>
              <p style={{ textAlign: 'left' }}>Install the device on the water tank for monitoring water level and connectivity with the water pump. This device comes with a unique customer identification key that helps access it through the mobile application.</p>
            </div>
            <div className="mobile-step01-div">
              <div className="step01-mobile" style={{ border: "1px solid #008F88" }}><p className="step01-mobile-head" style={{ backgroundColor: "#008F88" }}>Step 02</p></div>
              <h3 id="step01-h3">Mobile App Set-Up</h3>
              <p style={{ textAlign: 'left' }}>Download the Drop mobile application from play-store, enter the unique customer identification key to communicate with the installed device. Once the setup is complete, Drop starts gathering & logging data over the cloud.</p>
            </div>
            <div className="mobile-step01-div">
              <div className="step01-mobile" style={{ border: "1px solid #FF8402" }}><p className="step01-mobile-head" style={{ backgroundColor: "#FF8402" }}>Step 03</p></div>
              <h3 id="step01-h3">Data Monitoring & Controlling</h3>
              <p style={{ textAlign: 'left' }}>Monitor Water Level, Water Consumption, and Utilization through graphical & tabular data representation. Avoid water wastage & excessive usages with alerts and controls to operate water pumps.</p>
            </div>
          </div>
        </div>
        
      </div>

      {/* Third page End */}

      {/* Fourth Page */}
      <div className="Drop-fourth-page">
        <div className="drop-fourth-page-inner-div">
          <div className="drop-4-page-div-1">
            <p>
              Real-time water level
              detection using contact
              and non-contact type
              sensors
            </p>
          </div>
          <div className="drop-4-page-div-2">
            <p>
              Statistical
              representation of
              data in a graphical
              manner
            </p>
          </div>
          <div className="drop-4-page-div-3">
            <p id="Lets">Lets not forget the</p>
            <p id="p1">Features</p>
          </div>
          <div className="drop-4-page-div-4">
            <p>
              Multiple wireless
              connectivity options,
              low power consumption,
              and cost optimization.
            </p>
          </div>

          <div className="drop-4-page-div-5">
            <p>
              Storage of data
              is done through a
              secured cloud
              with minimum
              latency.
            </p>
          </div>
          <div className="drop-4-page-div-6">
            <p>
              Integrated Android
              application for monitoring
              and notifications.
            </p>
          </div>
          <div className="drop-4-page-div-7">
            <p>
              Export information
              about water consumption
              on a daily/monthly basis
              as PDFs/CSVs.
            </p>
          </div>
        </div>
      </div>
      {/* Fourth page End */}
      <BottomContact />
    </div>
  );
}

export default Drop;
